import queryString from 'query-string';
import { matchPath } from 'react-router';
import { allRoutes } from '../constants/Routes';
import { isEmceeConnect } from './package-connect-utils';
const ensureLeadingSlashOnly = path => "/".concat(path.split('/').filter(fragment => !!fragment).join('/'));
const stripMountPath = (path, mountPath) => ensureLeadingSlashOnly(path.replace(mountPath, '/'));
export const getMatchPath = _ref => {
  let {
    locationPath,
    routePath,
    mountPath
  } = _ref;
  return matchPath(stripMountPath(locationPath, mountPath), {
    path: routePath,
    exact: true,
    strict: false
  });
};
export const resolveCurrentRoute = (currentPath, mountPath) => allRoutes.find(r => getMatchPath({
  locationPath: currentPath,
  routePath: r.path,
  mountPath
}));
export const getUrlParams = () => queryString.parse(isEmceeConnect() ? window.location.hash.split('?')[1] : window.location.search);
export const getLocationPath = () => isEmceeConnect() ? window.location.hash.split('#')[1].split('?')[0] : window.location.pathname.split('/marketplace').pop();